import React from 'react';

interface TimesheetDescriptionProps {
    description: string;
    isEditing: boolean;
    inputId: string;
    onChange: (value: string) => void;
}

export const TimesheetDescription: React.FC<TimesheetDescriptionProps> = React.memo(({
    description,
    isEditing,
    inputId,
    onChange,
}) => {
    const hasError = !description.trim();

    return (
        <div className="timesheet-panel timesheet-description-panel">
            <div className="timesheet-panel__header">
                <label htmlFor={inputId}>Description</label>
            </div>
            <div className="timesheet-panel__body">
                {isEditing ? (
                    <textarea
                        className="form-control"
                        id={inputId}
                        value={description}
                        onChange={e => onChange(e.target.value)}
                        aria-label="Timesheet description"
                        aria-invalid={hasError}
                    />
                ) : (
                    <p
                        className={`timesheet-value ${
                            description.trim() ? '' : 'timesheet-value--empty'
                        }`}
                    >
                        {description}
                    </p>
                )}
            </div>
        </div>
    );
});

TimesheetDescription.displayName = 'TimesheetDescription';

